const { TRIAL_TARIFF_DAYS_DURATION } = require('../appConstants');
const {
    lite2024CommonName,
    professional2024CommonName,
    expert2024CommonName,
    ultimate2025CommonName,
} = require('./common-book-tariffs');

module.exports = {
    ULTIMATE_2025: {
        name: ultimate2025CommonName,
        description: `Alegerea ideală dacă îți dorești ceva unic și să folosești Zenamu fără nicio limitare`,
    },
    EXPERT_2024: {
        name: expert2024CommonName,
        description:
            'Am deja o practică stabilită și clienți fideli care revin la mine în mod constant. Organizez mai multe lecții pe săptămână și cursuri pe termen lung cu mai multe sesiuni.',
    },
    PROFESSIONAL_2024: {
        name: professional2024CommonName,
        description:
            'Am deja o practică stabilită și clienți fideli care revin la mine în mod constant. Organizez mai multe lecții pe săptămână și cursuri pe termen lung cu mai multe sesiuni.',
    },
    LITE_2024: {
        name: lite2024CommonName,
        description:
            'Organizez cursuri săptămânale regulate și, ocazional, ateliere specializate de weekend. Cursurile mele sunt destinate participanților obișnuiți.',
    },
    TRIAL_FREELANCER: {
        name: 'Versiune de probă cu funcționalități nelimitate',
        description: `Cu o nouă înregistrare, primiți ${TRIAL_TARIFF_DAYS_DURATION} zile de acces nelimitat la planul pentru instructori individuali.`,
    },
    TRIAL_STUDIO: {
        name: 'Versiune de probă cu funcționalități nelimitate',
        description: `Cu o nouă înregistrare, primiți ${TRIAL_TARIFF_DAYS_DURATION} de zile acces nelimitat la planul pentru studiouri.`,
    },
    FREE: {
        name: 'Instructor începător',
        description:
            'Țin cursuri neregulat și mai degrabă ocazional. Organizez doar câteva cursuri pe lună pentru un grup mic de participanți.',
    },
    FREELANCER_2024_COMPATIBILITY: {
        name: 'Profesionist',
        description: 'Sunt un instructor. Organizez lecții deschise, cursuri sau workshopuri.',
    },
    STUDIO_2024_COMPATIBILITY: {
        name: 'Studio',
        description: 'Organizăm cursuri, lecții deschise sau workshopuri susținute de diferiți instructori.',
    },
    STUDIO_PRO_2024_COMPATIBILITY: {
        name: 'Studio PRO',
        description: 'Organizăm cursuri, lecții deschise sau workshopuri susținute de diferiți instructori.',
    },
    DEPRECATED: {
        name: 'not available',
        description: 'tarif no longer available',
    },
};
